/**
 * Site-wide footer — brand + legal + fleet links.
 */
import type { CSSProperties } from "react";
import { Link } from "wouter";
import { BRAND } from "@shared/brand";
import { FLEET } from "@shared/fleet";

export function SiteFooter({ compact = false }: { compact?: boolean }) {
  const year = new Date().getFullYear();
  const linkStyle: CSSProperties = {
    color: "rgba(170, 200, 255, 0.9)",
    textDecoration: "none",
  };

  return (
    <footer
      style={{
        marginTop: "auto",
        padding: compact
          ? "1.25rem 1rem max(1.25rem, env(safe-area-inset-bottom))"
          : "2.5rem 1rem max(2rem, env(safe-area-inset-bottom))",
        textAlign: "center",
        color: "rgba(255,255,255,0.45)",
        fontSize: 13,
        borderTop: "1px solid rgba(255,255,255,0.06)",
        background: "rgba(5,5,15,0.65)",
      }}
    >
      {!compact && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            justifyContent: "center",
            marginBottom: 14,
            fontWeight: 600,
          }}
        >
          <Link href="/lobby" style={linkStyle}>
            Lobby
          </Link>
          <span style={{ opacity: 0.3 }}>·</span>
          <Link href="/slots" style={linkStyle}>
            Slots
          </Link>
          <span style={{ opacity: 0.3 }}>·</span>
          <Link href="/account" style={linkStyle}>
            Account
          </Link>
          <span style={{ opacity: 0.3 }}>·</span>
          <Link href="/connect" style={linkStyle}>
            Wallet
          </Link>
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          justifyContent: "center",
          marginBottom: 10,
        }}
      >
        <Link href="/privacy" style={linkStyle}>
          Privacy Policy
        </Link>
        <span style={{ opacity: 0.3 }}>·</span>
        <Link href="/terms" style={linkStyle}>
          Terms of Service
        </Link>
        <span style={{ opacity: 0.3 }}>·</span>
        <a href={FLEET.walletSite} style={linkStyle} target="_blank" rel="noreferrer">
          Wallet
        </a>
        <span style={{ opacity: 0.3 }}>·</span>
        <a href={FLEET.grudgeId} style={linkStyle} target="_blank" rel="noreferrer">
          Grudge ID
        </a>
      </div>

      <p style={{ margin: "0 0 6px", color: "rgba(255,248,231,0.55)", fontSize: 12 }}>
        {BRAND.name} ({BRAND.shortName}) · {BRAND.tagline}
      </p>
      <p style={{ margin: 0, fontSize: 12 }}>
        © {year} Grudge Studio ·{" "}
        <a href={BRAND.origin} style={linkStyle}>
          poker.grudge-studio.com
        </a>
        {" · "}
        18+ · Play responsibly · Digital GBUX only
      </p>
    </footer>
  );
}
